<template>
  <div class="laminar-turbulent-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Re = ρvd / μ | 雷诺数$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Pipe -->
          <line x1="0" y1="80" x2="400" y2="80" stroke="#444" stroke-width="2" />
          <line x1="0" y1="160" x2="400" y2="160" stroke="#444" stroke-width="2" />
          
          <!-- Liquid coloring -->
          <rect x="0" y="81" width="400" height="78" fill="rgba(88, 51, 255, 0.05)" />

          <!-- Streamlines / Dye -->
          <g v-for="(p, idx) in particles" :key="idx">
             <circle :cx="p.x" :cy="p.y" r="2" :fill="p.c" opacity="0.6" />
          </g>

          <text x="10" y="70" fill="#888" font-size="8">进流</text>
          <text x="360" y="70" fill="#888" font-size="8">出流</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>雷诺数 Re: {{ floorRe }}</label>
              <div class="value" :style="{color: isTurbulent ? '#ff4757' : '#2ed573'}">
                 类型: {{ isTurbulent ? '湍流 (紊乱)' : '层流 (平稳)' }}
              </div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节平均流速</label>
             <el-slider v-model="velocity" :min="1" :max="50" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>流体的流动状态由**雷诺数** 决定。当雷诺数较小时，粘性力占主导，流体各层之间平稳地平行滑动，不发生相互扰动，称为**层流**。当流速增大，雷诺数超过临界值（通常管流为2300），惯性力占据主导，流场中会出现无数漩涡，流动变得紊乱，称为**湍流**。湍流会大大增加流动阻尼，但在化工混合和热交换方面极具优势。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LaminarTurbulentViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      velocity: 10,
      particles: [],
      timer: null
    }
  },
  computed: {
    floorRe() { return Math.floor(this.velocity * 120); },
    isTurbulent() { return this.floorRe > 2300; }
  },
  methods: {
    update() {
       if (this.particles.length < 100) {
          this.particles.push({
             id: Math.random(),
             x: 0,
             y: 120 + (Math.random()-0.5)*40,
             c: Math.random() > 0.5 ? '#ff4757' : '#00d2ff',
             seed: Math.random() * 10
          });
       }

       this.particles.forEach((p, idx) => {
          let speed = this.velocity * 0.2;
          p.x += speed;
          
          if (this.isTurbulent) {
             // Add chaotic motion
             let intensity = (this.velocity - 20) * 0.1;
             p.y += (Math.sin(p.x * 0.05 + p.seed) + Math.cos(p.x * 0.1)) * intensity;
             // Keep inside pipe
             if (p.y < 85) p.y = 85;
             if (p.y > 155) p.y = 155;
          } else {
             // Return to smooth level
             let targetY = 120 + (p.y > 120 ? 20 : -20); // eslint-disable-line no-unused-vars
             // Actually, stay where you are but smooth
          }

          if (p.x > 400) this.particles.splice(idx, 1);
       });
       this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.laminar-turbulent-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(88, 51, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
